import { render } from "./MeetingPacks.vue?vue&type=template&id=05c60991&scoped=true"
import script from "./MeetingPacks.vue?vue&type=script&lang=js"
export * from "./MeetingPacks.vue?vue&type=script&lang=js"

import "./MeetingPacks.vue?vue&type=style&index=0&id=05c60991&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c60991"]])

export default __exports__